module.exports = __webpack_public_path__ + "static/img/angry.df510ab3.gif";